import { features } from '@/mocks/categories';

export default function FeatureCards() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-6 md:px-10">
        <div className="text-center mb-14">
          <p className="text-xs font-label tracking-widest uppercase text-accent-600 mb-3">
            Why Choose Us
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
            Why Mulebuy Spreadsheet?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="relative rounded-2xl overflow-hidden aspect-[3/4] md:aspect-[4/5] group cursor-default"
            >
              <img
                src={feature.imageUrl}
                alt={feature.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <div className="w-11 h-11 rounded-xl bg-background-50/20 backdrop-blur-sm flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-xl text-background-50`}></i>
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-2">
                  {feature.title}
                </h3>
                <p className="text-background-200/80 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}